import { UI } from '@skedulo/protobuf-web'
import { compareByRelevance } from '../../utils'
import { UiApiGetClientBaseV1 } from '../get-client-base'
import type { IApiPageTemplate, IPageTemplateGetRequest } from '../../../types'

const BASE_PATH = '/v1/page-templates'

export class PageTemplateUiApiClientV1 extends UiApiGetClientBaseV1<IApiPageTemplate> {
  get = async (
    request: IPageTemplateGetRequest,
  ): Promise<IApiPageTemplate | null> => {
    const response = await this.restGet<{ items: IApiPageTemplate[] }>(
      BASE_PATH,
      { slug: request.slug },
    )
    if (!response.items) throw new Error('Invalid response: missing "items"')
    // The list endpoint returns every template matching the slug (system-,
    // tenant-, and user-scoped). Pick the most specific (user > tenant >
    // system), matching the gRPC getPageTemplate resolution — otherwise a
    // tenant/user override is ignored in favour of the system template.
    const item = [...response.items].sort((a, b) =>
      compareByRelevance(a.page, b.page),
    )[0]
    if (!item) return null
    return {
      ...item,
      page: {
        ...item.page,
        pageType: UI.CRUD.pageTypeFromJSON(item.page.pageType),
      },
      template: {
        ...item.template,
        kind: UI.CRUD.kindFromJSON(item.template.kind),
      },
    }
  }
}
